import { useMemo, useCallback } from "react";
import {
	getInitialContestID,
	getContestIndexFromID,
	getContestIDFromIndex,
} from "../utils/contestUtils";

/**
 * useContestUtils - Hook for contest utility wrapper functions
 * Provides memoized contest utility functions that use component's local data
 */
export const useContestUtils = (userStore) => {
	const contests = useMemo(
		() => [
			"Glow Game",
			...(userStore.getContestNames() || []).filter(
				(name) => name.toLowerCase() !== "the glow game"
			),
		],
		[userStore]
	);

	const getInitialContestIDLocal = useCallback(
		() => getInitialContestID(userStore.user, userStore.user_roles),
		[userStore.user, userStore.user_roles]
	);

	const getContestIndexFromIDLocal = useCallback(
		(contestID) =>
			getContestIndexFromID(contestID, userStore.user_roles, contests),
		[userStore.user_roles, contests]
	);

	const getContestIDFromIndexLocal = useCallback(
		(index) => getContestIDFromIndex(index, userStore.user_roles, contests),
		[userStore.user_roles, contests]
	);

	return {
		contests,
		getInitialContestIDLocal,
		getContestIndexFromIDLocal,
		getContestIDFromIndexLocal,
	};
};

export default useContestUtils;
